<!-- eslint-disable vue/no-mutating-props -->
<template>
    <el-dialog
      v-model="show"
      :width="$vuetify.display.width <= 1400 ? 800 : $vuetify.display.width <= 1600 ? 1000 : $vuetify.display.width <= 2000 ? 1400 : $vuetify.display.width <= 2560 ? '75%' : '90%'"
      :fullscreen="$vuetify.display.width <= 800 ? true : false"
      :height="$vuetify.display.width <= 630 ? '550px' : '600px'"
      class="public-style"
      destroy-on-close
      align-center
      @close="close"
    >
    <div class="popUpTable">
        <div class="custom-table-design">
            <el-table :data="tableData"
                    class="my-2 data-table"
                    :height="$vuetify.display.width <= 630 ? '400px' : '600px'"
                    width="95%"
                    :fit="true"
                    stripe
                    v-loading="loading"
                    row-key="Instance ID"
                    >
                <el-table-column prop="Instance ID" :label="'Instance ID'" :width="$vuetify.display.width <= 1400 ? 150 : $vuetify.display.width <= 2560 ? 150 : ''" />
                <el-table-column prop="year" :label="'Year'" :width="$vuetify.display.width <= 1400 ? 150 : $vuetify.display.width <= 2560 ? 200 : ''">
                    <template #default="scope">
                        <span>{{ formatDateRange(scope.row.year) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ESTIMATED_BASELINE_EMISSIONS_OR_REMOVALS_(TCO2E)" :label="'ESTIMATED BASELINE EMISSIONS OR REMOVALS (tCO2-e)'" :width="$vuetify.display.width <= 1400 ? 250 : $vuetify.display.width <= 2560 ? 300 : ''" >
                  <template #default="scope">
                    {{
                    scope.row['ESTIMATED_BASELINE_EMISSIONS_OR_REMOVALS_(TCO2E)'] == null
                        ? ""
                        : (scope.row['ESTIMATED_BASELINE_EMISSIONS_OR_REMOVALS_(TCO2E)']).toLocaleString()
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="ESTIMATED_PROJECT_EMISSIONS_OR_REMOVALS _(TCO2E)" :label="'ESTIMATED PROJECT EMISSIONS OR REMOVALS (tCO2-e)'" :width="$vuetify.display.width <= 1400 ? 250 : $vuetify.display.width <= 2560 ? 300 : ''" >
                  <template #default="scope">
                    {{
                    scope.row['ESTIMATED_PROJECT_EMISSIONS_OR_REMOVALS _(TCO2E)'] == null
                        ? ""
                        : (scope.row['ESTIMATED_PROJECT_EMISSIONS_OR_REMOVALS _(TCO2E)']).toLocaleString()
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="ESTIMATED_LEAKAGE_EMISSIONS_(TCO2E)" :label="'ESTIMATED LEAKAGE EMISSIONS (tCO2-e)'" :width="$vuetify.display.width <= 1400 ? 200 : $vuetify.display.width <= 2560 ? 300 :  ''" >
                  <template #default="scope">
                    {{
                    scope.row['ESTIMATED_LEAKAGE_EMISSIONS_(TCO2E)'] == null
                        ? ""
                        : (scope.row['ESTIMATED_LEAKAGE_EMISSIONS_(TCO2E)']).toLocaleString()
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="ESTIMATED_NET_GHG_EMISSION_REDUCTIONS_OR_REMOVALS_(TCO2E)" :label="'ESTIMATED NET GHG EMISSION REDUCTIONS OR REMOVALS (tCO2-e)'" :width="$vuetify.display.width <= 1400 ? 300 : $vuetify.display.width <= 2560 ? 350 : ''" >
                  <template #default="scope">
                    {{
                    scope.row['ESTIMATED_NET_GHG_EMISSION_REDUCTIONS_OR_REMOVALS_(TCO2E)'] == null
                        ? ""
                        : (scope.row['ESTIMATED_NET_GHG_EMISSION_REDUCTIONS_OR_REMOVALS_(TCO2E)']).toLocaleString()
                    }}
                  </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
      <!-- </el-row> -->
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="me-primary"
            @click.stop="close"
            color="#ddf0ac"
          >
            <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
          </el-button>
        </span>
      </template>
    </el-dialog>
  </template>
  
  <script>
  
  // import moment from "moment";
  export default {
    props: {
      open_modal: {
        type: Boolean,
        default: false,
      },
      data_modal: {
        type: Array,
        // eslint-disable-next-line no-unused-vars
        default() {
          return [];
        },
      },
    },
    data() {
      return {
        show: this.open_modal,
        tableData: [],
        loading: false,
        allData: this.data_modal,
      };
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      open_modal: function (newVal) {
        this.show = newVal;
        if (newVal == true) {
          this.allData = this.data_modal;
          this.loadAllData();
        }
      },
    },
    methods: {
      close() {
        this.show = false;
        this.$emit("close_modal", false);
      },

      formatDateRange(dateRange) {
        if (!dateRange) return '';
        return dateRange.replace(' - ', ' to ');
      },

      loadAllData() {
        this.loading = true;
        setTimeout(() => {
          this.tableData = [...this.allData];
          this.loading = false;
        }, 300);
      },

            /**
       * Formats a table label by converting it to title case and replacing underscores with spaces.
       *
       * @param {string} label - The label to be formatted.
       * @returns {string} - The formatted label.
       *
       * Description:
       * - Converts the label to lowercase and splits it by underscores.
       * - Capitalizes the first letter of each word.
       * - Joins the words with spaces to form the formatted label.
       */
       formatTableLabel(label) {
        let splitLabel = label.toLowerCase().split("_");
            for (let i = 0; i < splitLabel.length; i++) {
            splitLabel[i] = splitLabel[i].replace(/\b\w/g, char => char.toUpperCase().replaceAll("TCO2E", "tCO2e"));
            }
            label = splitLabel.join(" ");
            return label;
        },
    },
  };
  </script>
  
  <style scoped>
  .el-dialog__body {
    padding: 30px 10px;
  }
  </style>
  